import { Locale } from "@omni/types/enums/locale.enum";
import { getLanguageTag } from "@omni/utils/locale.utils";

export async function addExternalScript(
    src: string,
    id: string
): Promise<void> {
    return new Promise((resolve) => {
        const existingScript = document.getElementById(id);
        if (existingScript) {
            return resolve();
        }

        const script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.id = id;
        script.src = src;
        script.onload = () => resolve();
        document.body?.appendChild(script);
    });
}

export const isEqual = (a: any, b: any) =>
    JSON.stringify(a) === JSON.stringify(b);

export const sortBy = (
    key: string,
    locale: Locale,
    caseSensitive: boolean = true
) => {
    const collator = new Intl.Collator(getLanguageTag(locale), {
        sensitivity: caseSensitive ? "variant" : "base"
    });

    return (a: any, b: any) => collator.compare(a[key], b[key]);
};

export const isEAN = (possibleEAN?: string) => {
    if (!possibleEAN) return false;
    let ean = possibleEAN.replace(/[^0-9]/g, "");
    if (ean.length < 12 || ean.length > 13) return false;
    if (ean.length !== 13) ean = ean.padStart(13, "0");
    const checkDigit = parseInt(ean[12], 10);
    const eanWithoutCheckDigit = ean.slice(0, 12);
    const eanWithoutCheckDigitArray = eanWithoutCheckDigit.split("");
    const sum = eanWithoutCheckDigitArray.reduce((acc, curr, index) => {
        if (index % 2 === 0) return acc + parseInt(curr, 10);
        return acc + parseInt(curr, 10) * 3;
    }, 0);
    const calculatedCheckDigit = (10 - (sum % 10)) % 10;
    return checkDigit === calculatedCheckDigit;
};
